import React from 'react'
import { subscribe } from 'react-contextual'
import styles from './PropertyAttachments.module.scss'
import DocumentInfo from 'modules/documents/DocumentInfo/DocumentInfo'
import { $TSFixMe } from 'types/ts-migrate'
import PropertiesProvider from 'modules/properties/PropertiesProvider'

const PropertyAttachments = ({ propertyViewId, viewData }: $TSFixMe) => {
  return (
    <div className={styles.root}>
      <section>
        <div className={styles['files-section']}>
          <DocumentInfo className="property" classId={propertyViewId} modalTitle={viewData.title} />
        </div>
      </section>
    </div>
  )
}

export default subscribe([PropertiesProvider], ({ propertyViewId, viewData }: any) => ({
  propertyViewId,
  viewData,
}))(PropertyAttachments)
